// Mirrors the `state` enum on the Strapi `location` content type.
export const US_STATE_CODES = [
    'AL',
    'AK',
    'AZ',
    'AR',
    'AS',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FL',
    'GA',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];

// Turns free text like "Dallas, TX" into Strapi location filters. A trailing
// 2-letter state code is matched against `state`; the rest is the city name.
export const buildLocationFilters = (input = '') => {
    const text = input.trim();
    if (!text) return { name: { $containsi: '' } };

    const tokens = text.split(/[\s,]+/).filter(Boolean);
    const state = tokens[tokens.length - 1].toUpperCase();
    if (!US_STATE_CODES.includes(state)) {
        return { name: { $containsi: text } };
    }

    const city = tokens.slice(0, -1).join(' ');
    if (!city) {
        return {
            $or: [{ state: { $eq: state } }, { name: { $containsi: text } }],
        };
    }

    return { name: { $containsi: city }, state: { $eq: state } };
};
